import React, { Component } from 'react'
import { Button, Panel } from 'react-bootstrap'
import { connect } from 'react-redux'
import { authenticatedUser, populatePopupError } from '../redux/actions'
import { Icon } from 'react-fa'
import $ from 'jquery'
import history from '../history'
import Input from '../components/elements/input'
import autobind from 'autobind-decorator'

@autobind
class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      processing: false
    }
  }

  handleUsernameChange = event => {
    this.setState({ username: event.target.value })
  }

  handlePasswordChange = event => {
    this.setState({
      password: event.target.value
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    if (this.validCredentials()) {
      var self = this
      this.setState({ processing: true })
      $.ajax({
        url: '/api/login',
        dataType: 'json',
        type: 'POST',
        data: { username: this.state.username, password: this.state.password },
        success: function(data) {
          self.setState({ processing: false })
          this.props.dispatch(authenticatedUser(data))
          return history.push('/search')
        }.bind(this),
        error: function(xhr, status, err) {
          console.log('error while logging in....!', err)
          // Task-71:When ajax request is completed then it'l set the processing to false
          this.setState({ processing: false })
          if (err === 'Unauthorized') {
            this.props.dispatch(populatePopupError('Bad credentials'))
          } else {
            this.props.dispatch(populatePopupError('Error logging in'))
          }
        }.bind(this)
      })
    }
  }

  validCredentials = () => {
    let valid = true
    if (!this.state.username || this.state.username === '') {
      this.props.dispatch(populatePopupError('Username is required to login'))
      valid = false
    }
    if (!this.state.password || this.state.password === '') {
      this.props.dispatch(populatePopupError('Password is required to login'))
      valid = false
    }
    if (
      (!this.state.username || this.state.username === '') &&
      (!this.state.password || this.state.password === '')
    ) {
      this.props.dispatch(
        populatePopupError('Username and Password are required to login')
      )
      valid = false
    }
    return valid
  }

  render() {
    return (
      <div
        className={
          'login-container container col-md-4 col-md-offset-4 ' +
          'col-xs-6 col-xs-offset-3'
        }
      >
        <Panel>
          <h2 className='text-center login-header'>
            <Icon name='sign-in' /> Sign in to Isha Stay
          </h2>
          <form onSubmit={this.handleSubmit}>
            <span className='label'>Username</span>
            <Input
              data-test-id='username'
              type='text'
              value={this.state.username}
              placeholder='Username'
              onChange={this.handleUsernameChange}
            />
            <span className='label'>Password</span>
            <Input
              data-test-id='password'
              type='password'
              value={this.state.password}
              placeholder='Password'
              onChange={this.handlePasswordChange}
            />

            <div className='text-center'>
              <Button
                bsStyle='primary'
                ref='login'
                disabled={this.state.processing}
                type='submit'
              >
                SIGN IN
              </Button>
            </div>
          </form>
        </Panel>
      </div>
    )
  }
}

//Which props do we want to inject, given the global state?
function selectProps(state) {
  return {
    auth: state.common.authentication
  }
}

//Wrap the component to inject dispatch and state into it
export default connect(selectProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/login.js